import {
    StyleSheet
} from "react-native";
import type {
    SidebarActionPlacement,
    SidebarMeasures
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        position: "absolute"
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    isInLabel,
    placement,
    measures,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    controlHeights: NCoreUIKit.ControlHeights;
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    placement: SidebarActionPlacement;
    measures: SidebarMeasures;
    isInLabel: boolean;
}) => {
    if(isInLabel) {
        return {
            container: {
                marginEnd: placement.endOffset,
                flexShrink: 0
            }
        };
    }

    return {
        container: {
            top: spaces.spacingSm + (controlHeights.small - placement.hitSize) / 2,
            end: measures.padding + placement.endOffset,
            zIndex: shapeConfigs.layers.raised
        }
    };
};
export default stylesheet;
